<template>
  <div class="plans">
    <span id="p-add-up">
      <PlanItemsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateId="updateId"
      ></PlanItemsAddUpdate>
    </span>
    <va-card :title="$t('plan-items.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#p-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="plan_items"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('planUpdate.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#p-add-up"
              @click="update(props.rowData.id)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData.id)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('planUpdate.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PlanItemsAddUpdate from './PlanItemsAddUpdate'
const perPage = 10
export default {
  name: 'PlanItems',
  components: { PlanItemsAddUpdate },
  methods: {
    showModal (id) {
      this.modalDeletar = true
      this.deleteId = id
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.plan_items.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_plan_item_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
    close (v) {
      this.showAdd = v
      this.updateId = null
    },
    update (id) {
      this.titleCard = 'update'
      this.updateId = id
      this.showAdd = true
    },
    open () {
      this.updateId = null
      this.showAdd = true
      this.titleCard = 'create'
    },
  },
  data () {
    return {
      perPage: perPage,
      plan_items: [],
      page: 1,
      showAdd: false,
      pages: null,
      loading: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateId: null,
    }
  },
  apollo: {
    plan_items: {
      query: gql`
      query MyQuery($page: Int, $perPage: Int) {
        plan_items: plan_item(limit: $perPage, offset: $page, order_by: {id: asc}) {
          id
          description
        }
      }
      `,
      variables () {
        return {
          perPage: this.perPage,
          page: 0,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($id: Int) {
        pages: plan_item_aggregate{
          aggregate {
            count
          }
        }
      }
      `,
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'description',
        title: this.$t('planUpdate.items.description'),
        width: '70%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('plans')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.planitems.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
